
import './main-layout.html';

const MainLayoutComponent = {
  bindings: {},
  template: require('./main-layout.html')
};


export default MainLayoutComponent;



// WEBPACK FOOTER //
// ./client/app/layout/main-layout/main-layout.component.js